export default __webpack_public_path__ + "static/helles-image-e07ced11e890f3ff3f93b3af02b17c39.png";